import { Button, Divider, Grid } from '@mui/material';
import { Form, Formik } from 'formik';
import React, { useState } from 'react'
import CustomAddCountryInput from '../../../../Components/CustomInputLogin/CustomAddCountryInput';
import * as Yup from "yup";
import actions from '../../../../ReduxStore/actions';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';

const CountryAdd = ({ setTabValue }) => {
    const [inputValue, setInputValue] = useState("");
    const [localValues, setLocalValues] = useState([]);


    const { AddCountryPost } = useSelector(
        (state) => state?.AddCountryPost
    );

   
    

    const dispatch = useDispatch()
    const handleSubmit = async (values) => {
        // if (!open) return;

        if (inputValue.trim() !== "") {
            values.country = [...values.country]; // Include the last typed value
        }


        const data1 = {
            data: {
                country_names: values.country
            },
            method: "post",
            apiName: `addMultipleCountries`
        };
        const responseData = await dispatch(actions.ADDCOUNTRYPOST(data1))

        // handleSubmit(values)
        console.log(values, "valuessssss")
        if (responseData?.payload?.message === "Countries added successfully.") {
            setInputValue("")
            setLocalValues([])
            setTabValue(1)
        }else{
            toast.error(responseData?.payload?.message)
        }
    };








    return (
        <div>
            <Formik
                enableReinitialize
                initialValues={{ country: [] }}
                validationSchema={Yup.object({
                    country: Yup.array().min(1, "At least one country is required"),
                })}
                onSubmit={(values, { setFieldValue }) => {
                    if (inputValue.trim() !== "") {
                        values.country = [...values.country]; // Include the last typed value
                    }

                    handleSubmit(values)
                    console.log(values, "valuessssss")
                    setInputValue("")
                    setLocalValues([])
                    setTabValue(1)
                }}
            >
                {({ handleSubmit, setFieldValue, resetForm, values }) => (
                    <Form onSubmit={handleSubmit}>
                        {/* <DialogContent dividers> */}
                        <Grid container spacing={2} mb={4}>
                            <Grid item xs={12} md={12}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} md={12}>
                                        <CustomAddCountryInput
                                            label="Country"
                                            name="country"
                                            inputType="text"
                                            custPlaceholder="Enter Country"
                                            setFieldValue={setFieldValue}
                                            values={values.country}
                                            inputValue={inputValue} // Pass inputValue
                                            setInputValue={setInputValue} //
                                            localValues={localValues}
                                            setLocalValues={setLocalValues}

                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Divider />


                        <Grid sx={{ display: "flex", justifyContent: "end", mt: 1 }}>
                            <Grid>
                                <Button
                                    onClick={() => {
                                        resetForm();
                                        // setUploadedFiles(null);
                                        // onClose()
                                        // dispatch(clearCustomerId(null))
                                        // dispatch(clearTableGetId(null))


                                    }}
                                    variant="text"
                                    // className="custom-clear-button"
                                    sx={{
                                        // backgroundColor: "#C38F51",
                                        textTransform: "none",
                                        color: "white",
                                        fontSize: "16px",
                                        mr: "10px",
                                        // padding: "0px 40px",
                                        padding: { xs: "0px 20px", md: "0px 40px" },

                                        minHeight: "40px",
                                        borderRadius: "23px",
                                        background: "white",
                                        boxShadow: "none",
                                        color: "black",
                                        border: "1px solid black",
                                        "&:hover": {
                                            backgroundColor: "#3B4056",
                                            color: "white",
                                        },
                                    }}
                                >
                                    Cancel
                                </Button>
                                <Button
                                    type="submit"
                                    variant="contained"
                                    // className="custom-ok-button"
                                    sx={{
                                        // backgroundColor: "#C38F51",
                                        textTransform: "none",
                                        color: "white",
                                        fontSize: "16px",
                                        boxShadow: "none",

                                        // padding: "0px 40px",
                                        padding: { xs: "0px 20px", md: "0px 40px" },

                                        minHeight: "40px",
                                        borderRadius: "23px",
                                        background: "#C38F51 0% 0% no-repeat padding-box",
                                        "&:hover": {
                                            backgroundColor: "#3B4056",
                                            boxShadow: "none",
                                        },
                                    }}
                                >
                                    {/* {customerId ? "Update" : "Submit"} */}

                                    Submit
                                </Button>
                            </Grid>
                        </Grid>
                        {/* </DialogContent> */}

                    </Form>
                )}
            </Formik>
        </div>
    )
}

export default CountryAdd